import { render } from "./InvoiceItem.vue?vue&type=template&id=311fa1b7&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"

import "./InvoiceItem.vue?vue&type=style&index=0&id=311fa1b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311fa1b7"]])

export default __exports__